import { useTranslations } from 'languages';
import { HomePageLayout } from 'modules/pages/HomePage';
import { FC } from 'react';
import { HomePagePropsType } from 'types/pages/HomePage';
import { siteText } from '../../siteText';

export const HomePage: FC<HomePagePropsType> = () => {
  // @ts-ignore
  ////ReactGA.pageview('/cosmetology');
  const t = useTranslations();

  const metaForCosmetologyHomePage = {
    title: t('metaCosmetology.title'),
    description: t('metaCosmetology.description'),
    keywords: t('metaCosmetology.keyWord'),
    slugs: {
      slug_uk: ' ',
      slug_ru: ' ',
      slug_en: ' ',
    },
  };

  return (
    <HomePageLayout siteText={siteText} metaForHomePage={metaForCosmetologyHomePage} />
  );
};
export default HomePage;
